module.exports = __webpack_public_path__ + "media/images/riders/ANNE_TERPSTRA-9388614c50dd6593da42d9f80ad5f579.png";